<template>
	<div>
		<!--<p @click='toggle'>{{model.label}}</p>
			<ul v-show="open" v-if='isFolder'>
				<items v-for='cel in model.children' :model='cel' style="margin-left: 20px;"></items>
			</ul>-->
		<div v-if="model.content.oid==0" style="display: flex;height: auto;background-color: white;border: 1px solid #e8e8e8;margin-bottom: 5px;">
			<div style="margin: auto;height: 120px;width: 120px;border-right: 1px solid #e8e8e8; ">
				<img :src="model.content.organizationSeal|addPath" style="height: 80%;width: 80%;margin: 10%;" />
			</div>
			<div style="flex: 2;" @click="run(model.content.id)">
				<p style="color: black;font-size: 16px;font-weight: 600;">{{model.content.orgName}}</p>
				<p><span style="color: black;">服务类型</span> | {{model.content.serviceType}}</p>
				<p><span style="color: black;">地区 </span>| {{model.content.regulatorArea}}</p>
				<p><span style="color: black;">详细地址 </span>| {{model.content.address}}</p>
			</div>
			<div style="flex: 0.4;min-width: 32px;text-align: center;" @click='toggle' v-if='isFolder'>
				<van-icon name="arrow-down" style="margin-top: 60px;" />
			</div>
		</div>
		<div v-if="model.content.oid!=0" style="height: auto;min-height: 60px;margin-bottom: 5px;background-color:white;display: flex;border: 1px solid #e8e8e8">
			<div style="margin: auto;height: 60px;width: 60px;border-right: 1px solid #e8e8e8;">
				<img :src="model.content.organizationSeal|addPath" style="height: 80%;width: 80%;margin: 10%;" />
			</div>
			<div style="flex: 2;background: white;"  @click="run(model.content.id)">
				<p style="color: black;font-size: 16px;font-weight: 600;">{{model.content.orgName}}</p>
				<p>地区 | {{model.content.regulatorArea}}</p>
			</div> 
			<div style="flex: 0.4;min-width: 32px;text-align: center;" @click='toggle' v-if='isFolder'>
				<van-icon name="arrow-down" style="margin-top: 25px;" />
			</div>
		</div>
		<transition name="fade" v-for='cel in model.children'>
			<items v-show="open" :model='cel' style="margin-left: 20px;"></items>
		</transition>
	</div>
</template>
<script type="text/javascript">
	import { Icon } from 'vant';
	import global from '@/api/global';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	export default {
		name: 'items',
		props: ['model'],
		components: {
			[Icon.name]: Icon
		},
		data() {
			return {
				open: false
			}
		},
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd');
			},
			addPath(path) {
				return global.resoursePhoto + "/" + path;
			}
		},
		computed: {
			isFolder: function() {
				return this.model.children && this.model.children.length
			}
		},
		methods: {
			run(id) {
				this.$router.push({
					path: '/organization_details', //跳转的路径
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: id
					}
				});
			},
			toggle: function() {
				if(this.isFolder) {
					this.open = !this.open
				}
			},
		}
	}
</script>

<style>
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .5s;
	}
	
	.fade-enter,
	.fade-leave-to
	/* .fade-leave-active below version 2.1.8 */
	
	{
		opacity: 0;
	}
</style>